/**
 * Where a freshly signed-in user belongs, read from their own access token.
 *
 * <p>Platform admins go straight to the console so the underwriter chrome never paints. Pure and
 * exported for that reason: it is base64url decoding inside a try/catch, and the failure mode of
 * getting it wrong - everyone routed to the wrong console - is not one to discover in a browser.
 * Anything unreadable routes to the workbench, which is the safe direction: the console guards
 * itself server-side, and a mis-parsed token must not hand someone the admin door.
 *
 * <p>It lives in its own module rather than beside the UserManager in oidc.ts because that file
 * builds the manager at import time from `window.location.origin`. A pure token-parsing function
 * that cannot be imported without a DOM is a function whose test has to stand up a browser to
 * decode base64 - and the test that did so failed on `window is not defined` under vitest's node
 * environment. Nothing here touches the DOM, so nothing importing it needs one.
 */
export function homePathForToken(accessToken: string | undefined | null): string {
  if (!accessToken) return '/';
  try {
    const payload = accessToken.split('.')[1];
    if (!payload) return '/';
    const claims = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))) as {
      realm_access?: { roles?: string[] };
    };
    return claims.realm_access?.roles?.includes('ADMIN') ? '/admin' : '/';
  } catch {
    return '/';
  }
}
